// TSP permission keys.
//
// This is a client-side mirror of the authoritative copy at
// modules/tsp/constants/tspPermissions.js in the brihadmrdanga-backend repo
// (kept in sync by hand — the two repos share no build-time dependency).
// This copy only ever gates what renders in the browser; it is NOT a
// security boundary. The backend's requireTspPermission is what actually
// protects data — see that repo's Phase 2 report for the full rationale
// behind this specific, curated set of keys (most areas get view/manage,
// a few get an explicit extra action where the requirements call one out).
const TSP_PERMISSIONS = Object.freeze({
  DASHBOARD_VIEW: "tsp.dashboard.view",

  TEAMS_VIEW: "tsp.teams.view",
  TEAMS_MANAGE: "tsp.teams.manage",

  JOURNEYS_VIEW: "tsp.journeys.view",
  JOURNEYS_MANAGE: "tsp.journeys.manage",
  JOURNEYS_APPROVE: "tsp.journeys.approve",
  JOURNEYS_START: "tsp.journeys.start",
  JOURNEYS_COMPLETE: "tsp.journeys.complete",
  JOURNEYS_CANCEL: "tsp.journeys.cancel",

  ROUTE_PLANNING_VIEW: "tsp.route_planning.view",
  ROUTE_PLANNING_MANAGE: "tsp.route_planning.manage",

  CITY_VISITS_VIEW: "tsp.city_visits.view",
  CITY_VISITS_MANAGE: "tsp.city_visits.manage",

  LOCATIONS_VIEW: "tsp.locations.view",
  LOCATIONS_MANAGE: "tsp.locations.manage",

  CONTACTS_VIEW: "tsp.contacts.view",
  CONTACTS_MANAGE: "tsp.contacts.manage",

  ACCOMMODATION_VIEW: "tsp.accommodation.view",
  ACCOMMODATION_MANAGE: "tsp.accommodation.manage",

  PARKING_VIEW: "tsp.parking.view",
  PARKING_MANAGE: "tsp.parking.manage",

  PRASADAM_VIEW: "tsp.prasadam.view",
  PRASADAM_MANAGE: "tsp.prasadam.manage",

  DAILY_REPORTS_VIEW: "tsp.daily_reports.view",
  DAILY_REPORTS_MANAGE: "tsp.daily_reports.manage",

  BOOK_DISTRIBUTION_VIEW: "tsp.book_distribution.view",
  BOOK_DISTRIBUTION_MANAGE: "tsp.book_distribution.manage",

  PUBLIC_RESPONSE_VIEW: "tsp.public_response.view",
  PUBLIC_RESPONSE_MANAGE: "tsp.public_response.manage",

  MEDIA_VIEW: "tsp.media.view",
  MEDIA_UPLOAD: "tsp.media.upload",

  ADVICE_VIEW: "tsp.advice.view",
  ADVICE_MANAGE: "tsp.advice.manage",

  KNOWLEDGE_REPOSITORY_VIEW: "tsp.knowledge_repository.view",

  FORUM_VIEW: "tsp.forum.view",
  FORUM_CREATE: "tsp.forum.create",
  FORUM_MODERATE: "tsp.forum.moderate",

  STORIES_VIEW: "tsp.stories.view",
  STORIES_CREATE: "tsp.stories.create",
  STORIES_MODERATE: "tsp.stories.moderate",

  REPORTS_VIEW: "tsp.reports.view",
  REPORTS_EXPORT: "tsp.reports.export",

  NOTIFICATIONS_VIEW: "tsp.notifications.view",
});

export default TSP_PERMISSIONS;
